// frontend/pages/Dashboard.js

import React from "react";
import Sidebar from "../components/Sidebar";
import CreateSurveyForm from "../components/CreateSurveyForm";
import { useAuth } from "../contexts/AuthContext";
import "./Dashboard.css";
import { Helmet } from "react-helmet";


const Dashboard = () => {
  const { user, logout } = useAuth();

  <Helmet>
  <title>AI Survey Development Platform | survai</title>
  <meta name="description" content="Build, edit, and share AI-powered surveys with survai." />
</Helmet>

  return (
    <div className="dashboard-container">
      <Sidebar
        userName={user?.name}
        onLogout={logout}
        onPurchaseTokens={() => console.log("Purchase Tokens Clicked")}
        isDarkMode={false} // Replace with actual dark mode state
      />
      <div className="main-content">
        <CreateSurveyForm />
      </div>
    </div>
  );
};

export default Dashboard;
